import { makeStyles } from '@material-ui/core/styles';


export const styles = makeStyles(() => ({
  imagePreview: {
    maxWidth: '40%',
    maxHeight: '150px',
  },
}));
